var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconePasta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00183C0 2.23969 2.23969 0.000815445 5.00182 0.00182111L10 0.00364089H12.5H13.7788C14.8941 0.00364089 15.9775 0.376577 16.8565 1.06314L18.6435 2.45887C19.5225 3.14543 20.6059 3.51837 21.7212 3.51837H44C46.7614 3.51837 49 5.75694 49 8.51837V37.5184C49 40.2798 46.7614 42.5184 44 42.5184H5C2.23858 42.5184 0 40.2798 0 37.5184V5.00183Z",
    fill: "#FF7A00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 49,
    height: 35,
    rx: 5,
    fill: "#FFA412"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePasta);
export default __webpack_public_path__ + "static/media/icone-pasta.d78eb357ef5525124a91cc0c0facd396.svg";
export { ForwardRef as ReactComponent };